import { useEffect, useState } from "react";
import { SessionKeys } from "../../utils/AppUtils";
import _ from "lodash";
import { useSelector } from "react-redux";
import { Spinner } from "react-bootstrap";
import SyncToggleComp from "./SyncToggleComp";
import { useNavigate } from "react-router-dom";

const EventCalendarTabsComponent = (props) => {
  const {
    getSessionsAccordingTab,
    monthHeader,
    weeksCount,
    setCurrentMonth,
    currentMonth,
    setSelectedSessionPos,
    googleSync,
    isSyncLoading,
    isHome,
    syncSessionFunc,
    setFromGuestUser,
    isLearn,
    isMobile,
    activeTab,
    setActiveTab
  } = props;
  const authBroker = useSelector((state) => state.auth.authBroker);
  
  const [activeTabWeek, setActiveTabWeek] = useState("");
  let navigate = useNavigate();

  const search = window.location.search;
  const params = new URLSearchParams(search);
  const isGuest = params.get("guest");
  const tabType = params.get("tabType");
  const currentMonthParam = params.get("currentMonth");
  const activeTabWeekParam = params.get("activeTabWeek");
  const b_name = _.isEmpty(params.get("b_name"))|| params.get("b_name")===undefined ||params.get("b_name")===null?"" :atob(params.get("b_name"));


  useEffect(() => {
    if (!_.isEmpty(authBroker)||true) {
      if(isGuest!=="true"){
      setActiveTab("currentWeek");
      getSessionsAccordingTab("currentWeek");
      }
    }
  }, [authBroker]);

  useEffect(() => {
    if (isGuest) {

      if(tabType===undefined||!tabType){
        setActiveTab("currentWeek");
      getSessionsAccordingTab("currentWeek");
      }else{
      setActiveTab(tabType)
      setActiveTabWeek(activeTabWeekParam);
      setCurrentMonth(Number(currentMonthParam));
      getSessionsAccordingTab(tabType,Number(currentMonthParam),activeTabWeekParam);
      if(Number(currentMonthParam)===0){
        setActiveTab("month");
      }
      if(tabType==="today" || tabType ==="tomorrow" || tabType==="currentWeek")
      setActiveTab(tabType)
      }
      setFromGuestUser(false);
    }
  }, [isGuest]);

  return (
    <>
      {!isLearn&& localStorage.getItem(SessionKeys.BROKER_NAME)!=="null" &&<div className="heading-events">
        {`${isGuest==="true"?b_name:localStorage.getItem(SessionKeys.BROKER_NAME)!==null?localStorage.getItem(SessionKeys.BROKER_NAME):""}`} Training
      </div>}
      <div className="d-sm-flex justify-content-between align-items-center mb-3 flex-md-wrap">
        <>
          <div className="d-flex cal_iconLR cal-btn-black">
            <button
              className="button-reset cursor-pointer"
              onClick={() => {
                let getMonth = _.cloneDeep(currentMonth) - 1;
                setCurrentMonth(getMonth);
                setActiveTab("prevMonth");
                setActiveTabWeek("monthView");
                setSelectedSessionPos(0);
                getSessionsAccordingTab("monthView", getMonth,"monthView");
              }}
              disabled={true ? "" : true}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                id="Back"
                width="30"
                height="30"
                viewBox="0 0 30 30"
              >
                <defs>
                  <linearGradient
                    id="linear-gradient"
                    y1="0.5"
                    x2="1"
                    y2="0.5"
                    gradientUnits="objectBoundingBox"
                  >
                    <stop offset="0" stopColor="#000000" />
                    <stop offset="1" stopColor="#000000" />
                  </linearGradient>
                </defs>
                <circle
                  id="Ellipse_57"
                  data-name="Ellipse 57"
                  cx="15"
                  cy="15"
                  r="15"
                  fill="url(#linear-gradient)"
                />
                <circle
                  id="Ellipse_179"
                  data-name="Ellipse 179"
                  cx="13"
                  cy="13"
                  r="13"
                  transform="translate(2 2)"
                  fill="#fff"
                />
                <g
                  id="Group_1344"
                  data-name="Group 1344"
                  transform="translate(22 15.002) rotate(135)"
                >
                  <path
                    id="Path_415"
                    data-name="Path 415"
                    d="M0,0H8V8"
                    transform="translate(8.001 0) rotate(90)"
                    fill="none"
                    stroke="#000000"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="4"
                  />
                </g>
              </svg>
            </button>
            <p className="calen">{monthHeader}</p>
            <button
              className="button-reset cursor-pointer"
              onClick={() => {
                let getMonth = _.cloneDeep(currentMonth) + 1;
                setCurrentMonth(getMonth);
                setActiveTab("nextMonth");
                setActiveTabWeek("monthView");
                setSelectedSessionPos(0);
                // getSessionsAccordingTab('nextMonth',getMonth)
                getSessionsAccordingTab("monthView", getMonth,"monthView");
              }}
              disabled={true ? "" : true}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                id="Next"
                width="30"
                height="30"
                viewBox="0 0 30 30"
              >
                <defs>
                  <linearGradient
                    id="linear-gradient"
                    y1="0.5"
                    x2="1"
                    y2="0.5"
                    gradientUnits="objectBoundingBox"
                  >
                    <stop offset="0" stopColor="#00b7f1"></stop>
                    <stop offset="1" stopColor="#ed156e"></stop>
                  </linearGradient>
                </defs>
                <circle
                  id="Ellipse_57"
                  data-name="Ellipse 57"
                  cx="15"
                  cy="15"
                  r="15"
                  fill="url(#linear-gradient)"
                ></circle>
                <circle
                  id="Ellipse_179"
                  data-name="Ellipse 179"
                  cx="13"
                  cy="13"
                  r="13"
                  transform="translate(2 2)"
                  fill="#fff"
                ></circle>
                <g
                  id="Group_1344"
                  data-name="Group 1344"
                  transform="translate(43.406 -779.787) rotate(45)"
                >
                  <path
                    id="Path_415"
                    data-name="Path 415"
                    d="M0,8H8V0"
                    transform="translate(536.5 587.5) rotate(-90)"
                    fill="none"
                    stroke="#000000"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="4"
                  ></path>
                </g>
              </svg>
            </button>
          </div>
          {isGuest || isLearn || true? (
            ""
          ) : (
            <SyncToggleComp
              googleSync={googleSync}
              isSyncLoading={isSyncLoading}
              isHome={isHome}
              syncSessionFunc={syncSessionFunc}
              from="list"
              isMobile={isMobile}
            />
          )}
        </>
      </div>
      <div className="d-flex justify-content-between gap-3 cal-mob">
        <div className="events-tabs-pills">
          <div
            className={`event-pill ${activeTab === "today" && "active-tab"}`}
            onClick={() => {
              setActiveTab("today");
              setActiveTabWeek("");
              setSelectedSessionPos(0);
              setCurrentMonth(0);
              getSessionsAccordingTab("today");
            }}
          >
            Today
          </div>
          <div
            className={`event-pill ${activeTab === "tomorrow" && "active-tab"}`}
            onClick={() => {
              setActiveTab("tomorrow");
              setActiveTabWeek("");
              setSelectedSessionPos(0);
              setCurrentMonth(0);
              getSessionsAccordingTab("tomorrow");
            }}
          >
            Tomorrow
          </div>
          <div
            className={`event-pill ${
              activeTab === "currentWeek" && "active-tab"
            }`}
            onClick={() => {
              setActiveTab("currentWeek");
              setActiveTabWeek("");
              setCurrentMonth(0);
              getSessionsAccordingTab("currentWeek");
            }}
          >
            This Week
          </div>
          <div
            className={`event-pill ${activeTab === "month" && "active-tab"}`}
            onClick={() => {
              setActiveTab("month");
              setActiveTabWeek("monthView");
              setSelectedSessionPos(0);
              setCurrentMonth(0);
              // getSessionsAccordingTab('month');
              getSessionsAccordingTab("monthView", 0,"monthView");
            }}
          >
            This Month
          </div>
        </div>
        {isGuest && false ? (
          <div>
            Already have an account?{" "}
            <span
              className="cursor-pointer text-decoration-underline"
              onClick={() => navigate("/login")}
            >
              Click here to Login!
            </span>
          </div>
        ) : (
          ""
        )}
      </div>

      {(activeTab === "month" ||
        activeTab === "monthView" ||
        activeTab === "nextMonth" ||
        activeTab === "prevMonth" ||
        activeTab.includes("week")) && (
        <div className="week-pills">
          <div
            className={`wekpill ${
              activeTabWeek === "monthView" && "active-tab"
            }`}
            onClick={() => {
              setActiveTabWeek("monthView");
              setSelectedSessionPos(0);
              getSessionsAccordingTab("monthView", currentMonth,"monthView");
            }}
          >
            {"Month View"}
          </div>
          {Array.from({ length: weeksCount }, (v, i) => {
            return (
              <div
                className={`wekpill ${
                  activeTabWeek === "week" + (i + 1) && "active-tab"
                }`}
                onClick={() => {
                  setActiveTabWeek("week" + (i + 1));
                  setSelectedSessionPos(0);
                  getSessionsAccordingTab("week" + (i + 1), currentMonth,"week" + (i + 1));
                }}
              >
                {"Week " + (i + 1)}
              </div>
            );
          })}
        </div>
      )}
    </>
  );
};
export default EventCalendarTabsComponent;
